import styled from 'styled-components';

import { ReactComponent as BaseIconFlights } from 'assets/images/rappi_flights.svg';
import Button from 'components/Buttons/Button';
import CheckboxComponent from 'components/Checkbox';

export const Container = styled.div`
  padding: 16px;
  background-color: #f9f9f9;
  min-height: 100%;
  @media ${({ theme }) => theme.device.desktop} {
    min-height: min(800px, 90vh);
  }
  @media ${({ theme }) => theme.device.mobile} {
    padding-top: 70px;
  }
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.04em;
  line-height: 115%;
`;

export const Subtitle = styled.h2`
  font-weight: 600;
  font-size: 16px;
  line-height: 125%;
  color: #332927;
`;

export const Fields = styled.ol`
  margin-top: 16px;
  background: #ffffff;
  box-shadow: 0px 6px 10px rgba(128, 98, 96, 0.16);
  border-radius: 12px;
  padding: 0 16px;
`;

export const Field = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #dbdbdb;

  &:last-child {
    border-bottom: 0;
  }
`;

export const SearchButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${({ theme }) => theme.device.mobile} {
    position: fixed;
    left: 0;
    bottom: 0px;
    right: 0;
    width: 100%;
    padding-bottom: 32px;
    box-shadow: 0px -6px 10px rgba(128, 98, 96, 0.16);
    background-color: #fff;
  }

  @media ${({ theme }) => theme.device.desktop} {
    position: absolute;
    left: 0;
    bottom: 0px;
    right: 0;
    width: 100%;
    padding: 0 16px 32px;
    box-shadow: 0px -6px 10px rgba(128, 98, 96, 0.16);
    background-color: #fff;
  }
`;

export const SearchButton = styled(Button)`
  height: auto;
  min-height: 55px;
  font-size: 16px;
  line-height: initial;
  padding: 14px;
  width: 100%;
  margin-top: 16px;
  margin-left: auto;

  @media ${({ theme }) => theme.device.mobile} {
    margin: 16px 16px 0px;
  }
`;

export const Checkbox = styled(CheckboxComponent)`
  cursor: pointer;
  & > span {
    border-radius: 4px;
  }

  @media ${({ theme }) => theme.device.desktop} {
    margin-left: auto;
  }
`;

export const Place: any = styled.div``;

Place.Type = styled.span`
  font-size: 12px;
  color: #706967;
`;
Place.Date = styled.span`
  font-size: 14px;
  color: #332927;
  font-weight: 600;
`;
Place.Local = styled.span`
  font-size: 12px;
  color: #706967;
`;

export const FlexRight = styled.div``;

export const IconFlights = styled(BaseIconFlights)`
  width: 24px;
  padding: 2px;
`;

export const SectionContainer = styled.div`
  padding: 16px 0;
  @media ${({ theme }) => theme.device.mobile} {
    margin-bottom: 80px;
  }
`;
